function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.5 33.25V30.0833C25.5 28.4036 24.8679 26.7927 23.7426 25.605C22.6174 24.4173 21.0913 23.75 19.5 23.75H7.5C5.9087 23.75 4.38258 24.4173 3.25736 25.605C2.13214 26.7927 1.5 28.4036 1.5 30.0833V33.25",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 17.4167C16.8137 17.4167 19.5 14.5811 19.5 11.0833C19.5 7.58553 16.8137 4.75 13.5 4.75C10.1863 4.75 7.5 7.58553 7.5 11.0833C7.5 14.5811 10.1863 17.4167 13.5 17.4167Z",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.5 33.2499V30.0833C34.499 28.68 34.0565 27.3168 33.242 26.2077C32.4276 25.0987 31.2872 24.3066 30 23.9557",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 4.95575C25.2906 5.30456 26.4346 6.09686 27.2515 7.20774C28.0684 8.31862 28.5118 9.6849 28.5118 11.0912C28.5118 12.4974 28.0684 13.8637 27.2515 14.9746C26.4346 16.0855 25.2906 16.8778 24 17.2266",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.2c29416d.svg";
export { ForwardRef as ReactComponent };